export default "__VITE_ASSET__CEUPE2P$__"